import {useState, useEffect} from 'react'

const DropdownMenu = ({
  currentUser,
  currentTest,
  handleDeactivateClick,
  handleOpenTestModal,
  id,
  currentAuditContext,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [isHovered, setIsHovered] = useState(false)

  useEffect(() => {
    const handleDropdownShow = () => setIsDropdownOpen(true)
    const handleDropdownHide = () => setIsDropdownOpen(false)

    const dropdownElement = document.getElementById('dropdownMenuTest')
    if (dropdownElement) {
      dropdownElement.addEventListener('show.bs.dropdown', handleDropdownShow)
      dropdownElement.addEventListener('hidden.bs.dropdown', handleDropdownHide)
    }

    return () => {
      if (dropdownElement) {
        dropdownElement.removeEventListener('show.bs.dropdown', handleDropdownShow)
        dropdownElement.removeEventListener('hidden.bs.dropdown', handleDropdownHide)
      }
    }
  }, [])

  const buttonStyle = {
    backgroundColor: isHovered || isDropdownOpen ? '#f3f4f6' : 'transparent',
    transition: 'background-color 0.2s ease',
  }

  return (
    <>
      {(currentUser?.role !== 'Auditor' && !currentAuditContext) && (
        <div className='dropdown' style={{position: 'relative', zIndex: 1200, marginLeft: 'auto'}}>
          <button
            className='btn btn-sm btn-icon border'
            type='button'
            id='dropdownMenuTest'
            data-bs-toggle='dropdown'
            aria-haspopup='true'
            aria-expanded={isDropdownOpen}
            style={buttonStyle}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
              className='icon icon-tabler icons-tabler-outline icon-tabler-dots'
            >
              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
              <path d='M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
              <path d='M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
              <path d='M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
            </svg>
          </button>
          <ul
            className='dropdown-menu px-2 fs-7'
            aria-labelledby='dropdownMenuTest'
            style={{borderRadius: '8px', zIndex: 1200}}
          >
            {currentTest && (
              <li>
                {currentTest.status !== 'Deactivated' ? (
                  <button
                    className='dropdown-item d-flex align-items-center justify-content-start hover:bg-gray-100 transition-colors duration-150'
                    style={{color: '#5A5A5A'}}
                    type='button'
                    onClick={handleDeactivateClick}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='18'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      className='icon icon-tabler icons-tabler-outline icon-tabler-clock-pause me-2'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M20.942 13.018a9 9 0 1 0 -7.909 7.922' />
                      <path d='M12 7v5l2 2' />
                      <path d='M17 17v5' />
                      <path d='M21 17v5' />
                    </svg>
                    Deactivate
                  </button>
                ) : (
                  <button
                    className='dropdown-item d-flex align-items-center justify-content-start hover:bg-gray-100 transition-colors duration-150'
                    style={{color: '#5A5A5A'}}
                    type='button'
                    onClick={() => handleOpenTestModal(currentTest)}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='18'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='#5A5A5A'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      className='icon icon-tabler icons-tabler-outline icon-tabler-clock-play me-2'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M12 7v5l2 2' />
                      <path d='M17 22l5 -3l-5 -3z' />
                      <path d='M13.017 20.943a9 9 0 1 1 7.831 -7.292' />
                    </svg>
                    Activate
                  </button>
                )}
              </li>
            )}
            <div className='separator my-2'></div>
            <li>
              <a
                href={`/tests/details/${id}`}
                target='_blank'
                rel='noopener noreferrer'
                className='dropdown-item d-flex align-items-center justify-content-start hover:bg-gray-100 transition-colors duration-150'
                style={{color: '#5A5A5A'}}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='18'
                  height='18'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  className='icon icon-tabler icons-tabler-outline icon-tabler-external-link me-2'
                >
                  <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                  <path d='M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6' />
                  <path d='M11 13l9 -9' />
                  <path d='M15 4h5v5' />
                </svg>
                Open in New Tab
              </a>
            </li>
          </ul>
        </div>
      )}
    </>
  )
}

export default DropdownMenu
